import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  IClearerReassignRequest,
  IClearerReassignResponse,
} from '../../models/clearer/clearerReassign.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import useHttps from '../useHttps';

const useReassignClearer = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const modalContext = useContext(ModalContext);
  const refreshTableContext = useContext(TableRefreshContext);

  const onReassignClearerError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating clearer'
    );
  };

  const onReassignClearerSuccess = ({
    message,
  }: SuccessHttpResponse<IClearerReassignResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const reassignClearer = (data: IClearerReassignRequest) => {
    const url: HttpConfig = {
      url: `general-service/v1/cargos/${data.cargoId}/clearer/${data.clearerId}`,
      method: 'put',
      data,
    };

    request(url, onReassignClearerSuccess, setLoading, onReassignClearerError);
  };

  return { reassignClearer, loading, resetInputFields };
};

export default useReassignClearer;
